import styled from 'styled-components';

export const S = {
  MenuWrapper: styled.div`
    height: 100%;
    flex: 1;
    overflow-y: auto;
  `,
};
